import { render, staticRenderFns } from "./GiftItem.vue?vue&type=template&id=756b609d&scoped=true&"
import script from "./GiftItem.vue?vue&type=script&lang=js&"
export * from "./GiftItem.vue?vue&type=script&lang=js&"
import style0 from "./GiftItem.vue?vue&type=style&index=0&id=756b609d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756b609d",
  null
  
)

export default component.exports